<template>
  <div class="card">
    <div class="card-body table-responsive-sm py-1">
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th class="border-top-0">Username</th>
            <th class="border-top-0"><span v-tooltip:top="'Number of submissions that this admin has processed'">Handled</span></th>
            <th class="border-top-0"><span v-tooltip:top="'Number of accepted submissions / processed submissions'">Ratio</span></th>
            <th class="border-top-0"><span v-tooltip:top="'The average number of Facebook interactions posts approved by this admin get'">Avg Interactions</span></th>
            <th class="border-top-0"><span v-tooltip:top="'How long since this admin processed a submission'">Last Activity</span></th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr v-for="admin in admins" v-bind:key="admin.id">
            <td>{{ admin.name }}</td>
            <td>{{ admin.truthsHandledCount }}</td>
            <td v-if="admin.ratio">{{ admin.ratio | round(3) }}</td>
            <td v-else></td>
            <td v-if="admin.avgInteractions">{{ admin.avgInteractions | round(3) }}</td>
            <td v-else></td>
            <td>{{ admin.timeLastTruthHuman }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopAdminsCard",

  props: {
    timescale: {
      type: String,
      Default: "Today"
    }
  },

  data() {
    return {
      loading: true,
      admins: []
    };
  },

  created() {
    this.loadTopAdmins();
  },

  methods: {
    loadTopAdmins() {
      this.loading = true;
      var self = this;
      axios
        .get("api/stats/admins", {
          params: {
            timescale: this.timescale
          }
        })
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length)
          self.admins = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>